<script lang="ts">
	import {
		// eslint-disable-next-line no-unused-vars
		ParaModal
		// OAuthMethod
	} from '@getpara/react-sdk';
	import '@getpara/react-sdk/styles.css';
	import { showParaModal } from '$lib/user/para/store';
	import { paraClient } from '../../user/para/client';

	const onClosed = async () => {
		showParaModal.set(false);
	};

	const CUSTOM_THEME = {
		backgroundColor: '#000000',
		darkBackgroundColor: '#000000',
		foregroundColor: '#12c17d',
		darkForegroundColor: '#12c17d',
		borderRadius: 'md',
		border: '#ffffff',
		darkBorder: '#ffffff',
		font: 'Arial, sans-serif',
		text: '#ffffff',
		darkText: '#ffffff',
		modalSurface: '#333333',
		darkModalSurface: '#333333',
		inputBackground: '#ffffff',
		darkInputBackground: '#ffffff',
		inputText: '#000000',
		buttonBackground: '#000000',
		buttonText: '#ffffff',
		mode: 'dark'
	};
	// Use this customTheme object in your modal or component configuration
</script>

<react:ParaModal
	logo={'/img/bloomLogoExplodedSm.png'}
	theme={CUSTOM_THEME}
	para={paraClient}
	isOpen={$showParaModal}
	onClose={onClosed}
	appName="Bloom Network"
	disablePhoneLogin={true}
	recoverySecretStepEnabled={true}
/>

<!-- disableBuy={true}
disableSwap={true} -->
<!-- twoFactorAuthEnabled={true} -->

<!-- oAuthMethods={Object.values(OAuthMethod)} -->

<!-- <ParaModal
	para={paraClient}
	isOpen={isModalOpen}
	onClose={() => setIsModalOpen(false)}
	logo={''}
	theme={{}}
	oAuthMethods={[]}
	disableEmailLogin={false}
	disablePhoneLogin={true}
	authLayout={['AUTH:FULL', 'EXTERNAL:FULL']}
	externalWallets={['METAMASK', 'PHANTOM']}
	// @getpara/evm-wallet-connectors is required to use an external EVM wallet.
	twoFactorAuthEnabled={false}
	recoverySecretStepEnabled={true}
	onRampTestMode

		onRampConfig={{
		asset: 'eth',
		providers: [
			{ id: 'STRIPE' }
			// Uncomment the following to add Ramp as a provider
			// {
			//   id: "RAMP",
			//   hostApiKey: "your-ramp-api-key",
			// },
		],
		testMode: true
	}}
/> -->
